import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import apiService from '../services/api';

const WhatsAppButton = () => {
  const [whatsappNumber, setWhatsappNumber] = useState('');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await apiService.getSettings();
      if (response.data.success) {
        setWhatsappNumber(response.data.data.whatsapp_number || '+919876543210');
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      setWhatsappNumber('+919876543210');
    }
  };

  const handleClick = () => {
    const message = encodeURIComponent('Hi! I would like to know more about your college consultation services.');
    const cleanNumber = whatsappNumber.replace(/[^0-9]/g, '');
    window.open(`https://wa.me/${cleanNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-110 z-50 animate-bounce-slow group"
      aria-label="Contact us on WhatsApp"
    >
      <FaWhatsapp className="text-3xl" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Chat with us!
      </span>
    </button>
  );
};

export default WhatsAppButton;
